import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  CART_RECOMMENDATION_CARDS_BLOCK_DATA_SOURCE,
  CartRecommendationCardsBlockDataSource,
} from './cart-recommendation-cards-block-view-model';
import { CartRecommendationCardsBlockPreviewDataSource } from './cart-recommendation-cards-block-preview-data-source';
import { CartRecommendationCardsBlockStoreDataSource } from './cart-recommendation-cards-block-store-data-source';

export function provideCartRecommendationCardsBlockDataSource(): Provider[] {
  return [
    CartRecommendationCardsBlockStoreDataSource,
    CartRecommendationCardsBlockPreviewDataSource,
    {
      provide: CART_RECOMMENDATION_CARDS_BLOCK_DATA_SOURCE,
      useFactory: (): CartRecommendationCardsBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(CartRecommendationCardsBlockPreviewDataSource)
          : inject(CartRecommendationCardsBlockStoreDataSource);
      },
    },
  ];
}
